<template lang="pug">
  #UnbindMember.h-100
    router-view
</template>

<script>
export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'UnbindMemberComponent'
};
</script>
